export const JSON_MEDIA_TYPE = "application/json";
export const TEXT_PLAIN_MEDIA_TYPE = "text/plain";
export const FORM_ENCODED_MEDIA_TYPE = "application/x-www-form-urlencoded";
export const MULTIPART_FORM_MEDIA_TYPE = "multipart/form-data";
